import React, { Component } from 'react';
import { connect } from 'react-redux';
import Config from '../../config/config';
import AdminLogin from '../../components/AdminLogin';
import AdminControl from '../AdminControl';
// import './About.css';

class Admin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loginSuccess: false,
      // loginSuccess: true,
    };

    this.login = this.login.bind(this);
    this.logout = this.logout.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  login(paramObj) {
    const { username, password } = paramObj;
    fetch(`${Config.apiUrl}/auth/local`, {
      method: 'POST',
      body: JSON.stringify({
        identifier: username,
        password,
      }),
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then(results => results.json())
      .then((data) => {
        if (data.user) {
          this.token = data.jwt;
          this.setState({
            loginSuccess: true,
          });
        }
      });
  }

  logout() {
    this.setState({
      loginSuccess: false,
    });
  }

  handleChange(event, key) {
    this.setState({
      [key]: event.target.value,
    });
  }

  render() {
    return (
      <div className="admin">
        <section className="section admin-container">
          {!this.state.loginSuccess && <AdminLogin login={this.login} />}
          {this.state.loginSuccess && <AdminControl logout={this.logout} token={this.token} />}
        </section>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  products: state.products,
  categories: state.categories,
  locations: state.locations,
  news: state.news,
});

export default connect(mapStateToProps)(Admin);



// WEBPACK FOOTER //
// ./src/containers/page/Admin.js